export default __webpack_public_path__ + "static/media/gallery_01.b73a785c.jpg";